(() => {
  let isFixed = false;

  const fixCookieBanner = () => {
    const banner = document.getElementById('coi-banner-wrapper');

    if (!banner || isFixed) {
      return;
    }

    const lang = document.documentElement.lang || 'no';
    const labelText = lang.toLowerCase().startsWith('en') ? 'Cookie information' : 'Cookie informasjon';

    let heading = banner.querySelector('h1');
    if (!heading) {
      heading = document.createElement('h1');
      heading.className = 'sr-only';
      heading.id = 'cookie-banner-heading';
      heading.textContent = labelText;
      banner.prepend(heading);
    }

    isFixed = true;
  };

  const initObserver = () => {
    fixCookieBanner();

    if (isFixed) {
      return;
    }

    const observer = new MutationObserver(_mutations => {
      const banner = document.getElementById('coi-banner-wrapper');
      if (banner) {
        fixCookieBanner();
        observer.disconnect();
      }
    });

    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: false,
        characterData: false
      });
    } else {
      // Fallback if body is not ready yet
      document.addEventListener('DOMContentLoaded', () => {
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: false,
          characterData: false
        });
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }
})();
